import { useState } from "react";
import { ddStyles } from "../utils/CommonStyles.js";

const UserProvisioningReadOnlyRow = ({ key, t, userProvisionedItem, handleSubmit, oddIdx, setAdd, setError }) => {
	const [isEdit, setIsEdit] = useState(false);
	const [isSubmit, setIsSubmit] = useState(false);
	const [isFlag, setIsFlag] = useState((userProvisionedItem && userProvisionedItem.flagValue === 1) ? true : false);
	let attributeKeyValues = {"IDirt-ANALYTICS":"IDirt Analytics Flag"};
	
	const handleEditClick = (event) => {
		setError("");
		setAdd(false);
		setIsEdit(true);
		setIsSubmit(false);
	};
	
	function submitCancel(event) {
		setError("");
		setIsEdit(false);
		setIsSubmit(false);
	}
	const flagHandler = (e) => {
		setIsFlag(e.target.checked);
	}
	function submitUpdate(event, userProvisionedItem) {
		event.preventDefault();
		setIsSubmit(true);
		let updatedValues = {
			provisionedAttribute: userProvisionedItem.provisionedAttribute,
			flagValue: isFlag ? 1 : 0
		};
		handleSubmit(2, updatedValues, submitUpdateComplete);
	}
	function submitUpdateComplete() {
		setError("");
		setIsSubmit(false);
		setIsEdit(false);
	}
	return (
		<tr key={key}>
			<td className={oddIdx ? "list-td col text-wrap text-center odd" : "list-td col text-wrap text-center even"}>{attributeKeyValues[userProvisionedItem.provisionedAttribute]}</td>
			{isEdit ? (
				<>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
					 	<input
							type="checkbox"
							name="flagValue"
							onChange={flagHandler}
							className="mycheckbox"
							styles={ddStyles}
							checked={isFlag}
							defaultChecked={true}
						/>
					</td>
				</>


			) : (
				<>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{""+isFlag}</td>
				</>
			)}
			<td className={oddIdx ? "list-td col col-md-auto odd" : "list-td col col-md-auto even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				{isEdit ? (
					<>
						<button className={isSubmit ? "btn btn-primary btn-block me-2 mb-1 pe-none" : "btn btn-primary btn-block me-2 mb-1"}
							onClick={(event) => submitUpdate(event, userProvisionedItem)}>{t("page.submit")}</button>
						<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"}
							onClick={(event) => (submitCancel(event))}>{t("page.cancel")}</button>
					</>
				) : (
					<>
						<button className={isSubmit ? "btn btn-primary btn-block me-2 mb-1 pe-none" : "btn btn-primary btn-block me-2 mb-1"}
							onClick={(event) => handleEditClick(event)}>{t("page.edit")}</button>
					</>
				)}

			</td>
		</tr>
	)
}
export default UserProvisioningReadOnlyRow;